module.exports = __webpack_public_path__ + "img/pie-bg2.b18ef17f.jpg";